import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Grid, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useUpdatePropertyMutation } from '../store/docApi';
import { Add } from '@mui/icons-material';
import LayoutCard from './LayoutCard';
import { generateEntityId, objectToArray } from '../utils';

export default function Layouts({ item }) {
  const navigate = useNavigate();
  const [updateProperty] = useUpdatePropertyMutation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newLayout, setNewLayout] = useState({ id: generateEntityId('layout'), name: '', description: '' });

  const onAddLayout = async () => {
    setIsDialogOpen(false);
    await updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `layouts/${newLayout.id}`, value: newLayout });
    setNewLayout({ id: generateEntityId('layout'), name: '', description: '' });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Layouts
      </Typography>
      <Grid container spacing={2}>
        {item.layouts &&
          objectToArray(item.layouts).map((layout) => (
            <LayoutCard key={layout.id} layout={layout} onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/layouts/${layout.id}`)} />
          ))}
      </Grid>
      <Button variant="outlined" startIcon={<Add />} onClick={() => setIsDialogOpen(true)} sx={{ mt: 2 }}>
        Add Layout
      </Button>

      {/* Add Layout Dialog */}
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth>
        <DialogTitle>Add New Layout</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ mr: 1 }}>
              {newLayout.id}
            </Typography>
          </Box>
          <TextField
            label="Name"
            value={newLayout.name}
            onChange={(e) => setNewLayout({ ...newLayout, name: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Description"
            value={newLayout.description}
            onChange={(e) => setNewLayout({ ...newLayout, description: e.target.value })}
            fullWidth
            size="small"
            multiline
            rows={2}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onAddLayout}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
